<template class="template-discrete-node">
    <div class="discrete-node">
       <div class="new-point">
            <div style="color:#505050;height:60px;line-height:60px;padding:0 24px;text-align:left;font-size:16px;">
                <span style="display:inline-block;width:5px;height:16px;background:#22d7bb;float:left;margin-top:22px;margin-right:8px;"></span>
                <span>创建节点</span>
            </div>
            <ul>
                <li >
                    离散分支
                    <a-icon type="plus-circle" />
                </li>
            </ul>
        </div>
        <div class="content" :class="{'active':ifShowDetail}" id="chatDiv">
            <div class="area">
                <div style="margin-top:16px" :class="{'active':index==selectCurrentIndex}" v-for="(item, index) in nodeList" :key="index" @click="selectCurrentItem(item,index)">
                    <div class="list" v-if="item.type=='DISPERSED'">
                        <div class="operation">
                            <span style='background:#e5f9ff;color:#00c8ff;margin-left:30px'>离散节点</span>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px">最大次数：</span>
                            <span style="color:rgba(78, 138, 250, 1)">{{ item.maxTriggerCount }}</span>
                            <span style="margin-left:20px;color:rgba(204, 204, 204, 1);font-size:14px">触发意图：</span>
                            <a-select :defaultValue="item.preIntentionId" :key="item.preIntentionId" style="width: 220px;" @change="handleChange">
                                <a-select-option :value=-1 :key=-1>空</a-select-option>
                                <a-select-option :title="newItem.name" :value='newItem.id' v-for="(newItem, newIndex) in intentionSelectList" :key="newIndex">{{newItem.name}}</a-select-option>
                            </a-select>
                            <div class="right operation-list">
                                <a-icon class="arrow-up" @click="moveNodePlace(item.id, 1)" v-if="index!=0" type="arrow-up" />
                                <a-icon class="arrow-down" @click="moveNodePlace(item.id, 2)" v-if="index!=(nodeList.length-1)" type="arrow-down" />
                                <a-icon class="delete" type="delete" @click="confirm(item.id)" />
                            </div>
                        </div>
                        <div class="area-edit">
                            <span class="serial-number">{{index+1}}</span>
                            <a-input v-model='item.name' @blur="changeLinesName(item)" />
                            <a-icon class="add" type="diff" @click="addLines(null,item.id)"/>
                        </div>
                        <div class="area-list">
                            <draggable element="span" v-model="item.talkingSkillList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false">
                                <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                    <li class="list-content list-group-item" v-for="(talkingItem, talkingIndex) in item.talkingSkillList" :key="talkingIndex">
                                        <a-textarea style="line-height:20px;height:65px;resize:none;" @blur="addLines(talkingItem)" v-model='talkingItem.content' />
                                        <a-icon type="drag" />
                                        <a-icon type="minus-circle" @click="removeLines(talkingItem.id,item.id)" />
                                    </li>
                                </transition-group>
                            </draggable>
                        </div>
                    </div>
                    <!-- <div class="list" v-if="item.type!='DISPERSED'">
                        <div class="operation">
                            <span style='background:rgba(34, 215, 187, 0.1);color:rgba(34, 215, 187, 1)'>离散分支</span>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px">最大次数：</span>
                            <span style="color:rgba(204, 204, 204, 1)">{{ item.maxTriggerCount }}</span>
                            <div class="right operation-list">
                                <a-icon class="arrow-up" @click="moveNodePlace(item.id, 1)" v-if="index!=1" type="arrow-up" />
                                <a-icon class="arrow-down" @click="moveNodePlace(item.id, 2)" v-if="index!=(nodeList.length-1)" type="arrow-down" />
                                <a-icon class="delete" type="delete" @click="confirm(item.id)"/>
                            </div>
                        </div>
                        <div class="area-edit">
                            <span class="serial-number">{{index+1}}</span>
                            <a-input v-model='item.name' @blur="changeLinesName(item)" />
                            <a-icon class="add" type="diff" @click="addLines(null)"/>
                        </div>
                        <div class="area-list">
                            <div class="list-content" v-for="(talkingItem, talkingIndex) in item.talkingSkillList" :key="talkingIndex">
                                <a-textarea style="line-height:20px;height:65px" @blur="addLines(talkingItem)" v-model='talkingItem.content' />
                                <a-icon type="minus-circle" @click="removeLines(talkingItem.id)"/>
                            </div>
                        </div>
                        <div class="distribution" style="width:100%">
                            <a-icon class="up-down" style='position:absolute;right:44px;bottom:0px' @click='ifShow(index)' v-if="!boolList[index]"  type="down" />
                            <div style="width:80%;padding-bottom:28px">
                                <div v-if="boolList[index]" class="gutter-example">
                                    <a-row :gutter="16">
                                        <a-col class="gutter-row" :span="12">
                                            <div class="gutter-box gutter-box1">
                                                <div class="distribution-text">待分配意图</div>
                                                <draggable element="span" v-model="item.unDistributeIntentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" :move="onMove">
                                                    <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                        <li class="idea list-group-item" v-for="(waitingItem, waitingIndex) in item.unDistributeIntentionList" :key="waitingIndex">
                                                            <div>{{waitingItem.name}}</div>
                                                            <a-icon class="add move" type="drag" />
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                            </div>
                                        </a-col>
                                        <a-col class="gutter-row" :span="12">
                                            <div style="text-align:center;cursor:pointer;margin:10px 0 20px 0">
                                                <a-icon type="plus" />
                                                <span style='margin-left:5px' @click="addJumpLogic(item.id,index)">跳转逻辑</span>
                                            </div>
                                            <div v-if="testArr[index].state" style="min-height:80px;padding:8px;background:#f5f5f5;margin-bottom:10px;border: rgba(166, 166, 166, 1) dotted 1px;">
                                                <div class="add-point">
                                                    <a-select defaultValue="请选择" style="width: 80%" @change="handleChange2" @focus="queryNodeSelectList(null)">
                                                        <a-select-option :title="selectItem.name" :value="selectItem.id" v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon @click="removeTemporaryNode" type="delete" style="float:right" />
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="testArr[index].data" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(index,false)">
                                                        <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                            <div class="list-content" v-for="(talkingItem, talkingIndex) in testArr[index].data" :key="talkingIndex">
                                                                <span>{{talkingItem.name}}</span>
                                                                <a-icon class="move" type="drag"/>
                                                                <a-icon type="minus-circle" @click="removeLines(talkingItem.id)"/>
                                                            </div>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                            <div class="gutter-box gutter-box2" v-for="(allocateItem, allocateIndex) in item.nextNodeList" :key="allocateIndex">
                                                <div class="add-point">
                                                    <a-select :defaultValue="allocateItem.name" :key="allocateItem.name" style="width: 80%" @change="(e)=>handleChange1(e,allocateItem.id)" @focus="queryNodeSelectList(allocateItem.id)">
                                                        <a-select-option :title="selectItem.name" :value='selectItem.id' v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon type="delete" style="float:right" @click="deleteNextNode(allocateItem.id)"/>
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="allocateItem.intentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(allocateItem,true)" :move="onMove">
                                                        <transition-group name="no" class="list-group" tag="ul">
                                                            <li class="list-group-item list-point" v-for="(desItem, desIndex) in allocateItem.intentionList" :key="desIndex">
                                                                <div>{{desItem.name}}</div>
                                                                <a-icon class="move" type="drag" />
                                                                <a-icon type="minus-circle" @click="deleteAssignedIntention(desItem.id)"/>
                                                            </li>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>
                            <a-icon class="up-down" style='position:absolute;right:44px;bottom:0px' @click='ifShow(index)' v-if="boolList[index]" type="up" />
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <a-icon v-if="!ifShowDetail" type="left-circle" style="position:fixed;right:5px;top:50%;color:rgba(204, 204, 204, 1);font-size:24px" @click="openDetail"/>
        <div class="detail" v-if="ifShowDetail">
            <a-icon v-if="ifShowDetail" type="right-circle" style="position:absolute;left:-12px;top:45%;color:rgba(204, 204, 204, 1);font-size:24px" @click="closeDetail"/>
            <div class="title">
                <span>节点{{selectCurrentIndex+1}}-高级配置</span>
            </div>
            <div class="tags">
                <span style="background:#e5f9ff;color:#00c8ff">离散节点</span>
            </div>
            <div class="max-times">
                <span>最大次数</span>
                <a-input-number style="width:120px" :min="0" :max="1000" v-model="maxTriggerCount" @change="onChange1" />
            </div>
            <div class="interrupt">
                <span>能否打断</span>
                <a-radio-group v-model="canInterrupt" @change="onChange3">
                    <a-radio-button value="true">是</a-radio-button>
                    <a-radio-button value="false">否</a-radio-button>
                </a-radio-group>
            </div>
            <div class="interrupt">
                <span>默认路由</span>
                <a-select :defaultValue='defaultSelectNode' :key="defaultSelectNode" v-model='defaultSelectNode' style="width: 210px" @change="onChange5">
                    <a-select-option :value=-1 :key=-1>空</a-select-option>
                    <a-select-option :disabled="currentNodeId==item.id" :title='item.name' v-for="(item, index) in selectNodeList" :key="index" :value='item.id'>{{item.name.length>12?(item.name).substring(0,12)+'...':item.name}}</a-select-option>
                </a-select>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    name: 'DiscreteNode',
    props: {
        msg: String
    },
    components: {
      draggable
    },
    data() {
        return {
            isDragging: false,
            delayedDragging: false,
            projectId: '',
            nodeList: [],
            alarmList: [],
            nodeId: '',
            ifShowDetail: false,
            maxTriggerCount: null,
            canInterrupt: null,
            ifShowData: true,
            currentNodeId: '',
            intentionSelectList: [],
            selectCurrentIndex: null,
            defaultSelectNode: null,
            selectNodeList: [],
        };
    },
    methods: {
        handleChange(value) {
            let selectedIntentionId = value
            this.axios.post('/api/project/node/intention/preIntention', {
                projectId: this.projectId,
                nodeId: this.currentNodeId,
                intentionId: selectedIntentionId
            })
            .then(response=> {
                if(response.data.code != 0){
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange1(value) {
            this.maxTriggerCount = value
            this.axios.post('/api/project/node/maxTriggerCount', {
                id: this.currentNodeId,
                maxTriggerCount: value
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange3(e) {
            this.canInterrupt = e.target.value
            this.axios.post('/api/project/node/canInterrupt', {
                id: this.currentNodeId,
                canInterrupt: this.canInterrupt=='true'?true:false
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        removeNode(id) {
             this.axios.post('/api/project/node/delete', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        addPoint() {
            this.$confirm({
                title: '提示',
                content: '确定要新增离散节点吗？',
                okText: '确定',
                cancelText: '取消',
                icon: 'exclamation-circle',
                onOk: ()=> {
                    this.newNode()
                },
            })
        },
        newNode() {
            this.axios.post('/api/project/node', {
                projectId: this.projectId,
                nodeType: 'DISPERSED'
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData("addPoint")
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        ifShow() {
            this.ifShowData = !this.ifShowData
        },
        queryNodeData(type) {
            this.axios( 
                {
                    method:'get',
                    url:'/api/project/node/dispersed/list', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    if(type == "addPoint"){
                        this.selectCurrentIndex = response.data.data.length - 1
                        this.selectCurrentItem(response.data.data[this.selectCurrentIndex],this.selectCurrentIndex)
                        this.scrollTopCon()
                    }
                    this.nodeList = response.data.data
                    if(type == 'orderUp'){
                        this.selectCurrentIndex--
                    }else if(type == 'orderDown'){
                        this.selectCurrentIndex++
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryAlarmData() {
            this.axios(
                {
                    method:'get',
                    url:'/api/project/node/alerm', 
                    params: {
                        projectId: this.projectId,
                        nodeId: this.nodeId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.alarmList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        selectCurrentItem(item,index) {
            this.maxTriggerCount = item.maxTriggerCount
            this.canInterrupt = item.canInterrupt+''
            this.currentNodeId = item.id
            this.selectCurrentIndex = index
            this.defaultSelectNode = item.defaultRedirectNodeId
            
        },
        queryIntentionSelect() {
            this.axios(
                {
                    method:'get',
                    url:'/api/dropdown/preIntention', 
                    params: {
                        projectId: this.projectId,
                        currentIntentionId: ''
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.intentionSelectList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        trim(s){
            return s.replace(/(^\s*)|(\s*$)/g, "");
        },
        changeLinesName(item) {
            if(this.trim(item.name).length > 0){
                this.axios.post('/api/project/node/name', {
                    id: item.id,
                    name: item.name
                })
                .then(response=> {
                    if(response.data.code != 0){
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }else{
                this.$message.error('名称不能为空');
                this.queryNodeData()
            }
        },
        getLength(str) {
            let realLength = 0, len = str.length, charCode = -1;
            for (let i = 0; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode >= 0 && charCode <= 128) realLength += 1;
                else realLength += 2;
            }
            return realLength
        },
        addLines(item,id) {
            let itemId = '', itemContent = ''
            if(item != null){
                itemId = item.id
                itemContent = (item.content).replace(/\s/g,"")
            }else{
                if(id != this.currentNodeId){
                    return false
                }
            }
            if(this.getLength(itemContent) > 2000){
                this.$message.error('台词内容太多，无法解析。请删减');
            }else{
                this.axios.post('/api/talkingSkill', {
                    id: itemId,
                    projectId: this.projectId,
                    nodeId: this.currentNodeId,
                    content: itemContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryNodeData()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
            
        },
        removeLines(talkingId,itemId) {
            if(itemId != this.currentNodeId){
                return false
            }
            this.axios.post('/api/talkingSkill/delete', {
                id: talkingId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        confirm(id) {
            if(id != this.currentNodeId){
                return false
            }
            this.$confirm({
                title: '提示',
                content: '确认要删除吗？',
                okText: '确认',
                cancelText: '取消',
                icon: 'warning',
                onOk: ()=> {
                    this.removeNode(id)
                },
            })
        },
        closeDetail() {
            this.ifShowDetail = false
        },
        openDetail() {
            if(this.currentNodeId != ""){
                this.ifShowDetail = true 
            }
        },
        scrollTopCon() {
            this.$nextTick(function() {
                let div = document.getElementById('chatDiv');
                div.scrollTop = div.scrollHeight;
            })
        },
        moveNodePlace(id, direction) {
            if(id != this.currentNodeId){
                return false
            }
            this.axios.post('/api/project/node/orderNo', {
                id: id,
                direction: direction,
            })
            .then(response=> {
                if(response.data.code == 0){
                   
                    if(direction==1){
                        this.queryNodeData('orderUp')
                    }else{
                        this.queryNodeData('orderDown')
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange5(value) {
            this.axios.post('/api/project/node/defaultRedirect', {
                id: this.currentNodeId,
                redirectNodeId: value
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySelectNode() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/dropdown/node', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.selectNodeList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          ghostClass: "ghost"
        };
      },
    },
    watch: {
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      }
    },
    mounted: function() {
        this.sessionData('set','contentNavItem','sync');
        this.projectId = this.$route.query.projectId
        this.queryNodeData()
        this.querySelectNode()
        this.queryIntentionSelect()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
    .discrete-node{
        .list-group-item {
            transition: transform 1.5s;
        }
        input{
            border-color:rgba(238, 238, 238, 1);
        }
        textarea{
            border-color:rgba(238, 238, 238, 1);
        }
        select{
            border-color:rgba(238, 238, 238, 1);
        }
        i{
            cursor: pointer;
        }
        i.move{
            cursor: move;
        }
        i:hover{
            color: #2672FF;
        }
        .right{
            float: right;
        }
        .left{
            float: left;
        }
        background: #F5F5F5;
        height: 100%;
        padding: 8px 0 24px 24px;
        .new-point{
            width: 240px;
            height: 100%;
            position: fixed;
            left:64px;
            background-color: #fff;
            color: #fff;
            top: 48px;
            font-size: 14px;
            // padding-top:24px;
            li{
                height: 48px;
                // text-align: center;
                line-height: 48px;
                padding-left:48px;
                font-size: 14px;
                color: rgba(80, 80, 80, 1);
                cursor: pointer;
                i{
                    margin-left: 5px;
                }
            }
            li:hover{
                background: rgba(34, 215, 187, 0.1);
                i{
                    color: rgba(34, 215, 187, 1);
                }
            }
        }
        .content{
            height: 100%;
            overflow-y: auto;
            padding: 0 24px 60px 240px;
            .title{
                width: 100%;
                height: 252px;
                background: #fff;
                padding: 24px;
                input{
                    // width: 90%;
                    height: 32px;
                    border: 1px solid rgba(238, 238, 238, 1);
                    // margin: 0 auto 8px;
                    line-height: 32px;
                    color: #000;
                    display: block;
                    text-align: center;
                    font-size: 16px;
                }
                textarea{
                    // width: 90%;
                    min-height: 32px;
                    border: 1px solid rgba(238, 238, 238, 1);
                    // margin: 0 auto 8px;
                    line-height: 32px;
                    color: #000;
                    display: block;
                    // padding-left: 10px;
                    font-size: 12px;
                }
            }
            .area{
                i:hover{
                    color: rgba(34, 215, 187, 1);
                }
                div.active{
                    border: 2px dotted #22d7bb;
                }
                .list{
                    // margin-top: 16px;
                    background: #fff;
                    padding: 24px;
                    border-radius: 4px;
                    min-height: 204px;
                    .operation{
                        span{
                            display: inline-block;
                            text-align: center;
                            line-height: 24px;
                        }
                        span:nth-child(1){
                            margin-right: 18px;
                            width: 70px;
                            height: 24px;
                        }
                        .operation-list{
                            display: none;
                            i{
                                margin-right: 15px;
                                font-size: 20px;
                            }
                            i.arrow-up:hover{
                                color: rgba(34, 215, 187, 1) !important;
                            }
                            i.arrow-down:hover{
                                color: rgba(34, 215, 187, 1) !important;
                            }
                            i.delete:hover{
                                color: rgba(255, 141, 26, 1) !important;
                            }
                        }
                    }
                }
                .list:hover{
                    .operation-list{
                        display: inline-block;
                    }
                }
                .area-edit{
                    margin-top: 18px;
                    .serial-number{
                        display: inline-block;
                        width: 30px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 12px;
                        color: rgba(80, 80, 80, 1);
                    }
                    input{
                        width: 80%;
                    }
                    .add{
                        margin-left: 10px;
                        font-size: 20px;
                        cursor: pointer;
                        display: none;
                    }
                }
                .area-edit:hover{
                    .add{
                        display: inline-block;
                    }
                }
                .area-list{
                    .list-content{
                        margin-top: 12px;
                        textarea{
                            width: 80%;
                            margin-left: 30px;
                            margin-right: 12px;
                            resize:none;
                        }
                        i{
                            margin-right: 15px;
                            font-size: 20px;
                            display: none;
                        }
                    }
                }
                .area-list:hover{
                    i{
                        display: inline-block;
                    }
                }
                .distribution{
                    width: 80%;
                    position: relative;
                    // height: 100px;
                    // border: 1px solid #ccc;
                    margin-left: 30px;
                    margin-top: 24px;
                    .gutter-example .ant-row > div {
                        background: transparent;
                        border: 0;
                    }
                    .gutter-box {
                        // padding: 5px 0;
                        color: rgba(80, 80, 80, 1);
                        background-color: rgba(245, 245, 245, 1);
                        padding: 16px;
                        font-size: 12px;
                        border: rgba(166, 166, 166, 1) dotted 1px;
                        margin-bottom: 8px;
                    }
                    .gutter-box1{
                        padding-bottom: 50px;
                        .distribution-text{
                            margin-bottom: 11px;
                        }
                        .idea{
                            margin-bottom: 2px;
                            input{
                                width: 80%;
                                border:rgba(166, 166, 166, 1) dotted 1px;
                            }
                            i{
                                margin-left: 8px;
                                font-size: 14px;
                            }
                        }
                    }
                    .gutter-box2{
                        .add-point{
                            margin-bottom: 8px;
                            i{
                                float: right;
                                margin-top: 10px;
                            }
                        }
                        .list-point{
                            margin-bottom: 2px;
                            input{
                                width: 80%;
                            }
                            i{
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }
        }
        .content.active{
            padding: 0 340px 60px 240px;
        }
        .detail{
            width: 320px;
            height: 100%;
            position: fixed;
            right: 0px;
            top: 47px;
            // border: 1px solid red;
            padding: 27px 16px 0;
            background: #fff;
            .title{
                span:nth-child(1){
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                }
                span:nth-child(2){
                    margin-left: 5px;
                }
            }
            .tags{
                margin-top:16px;
                span{
                    padding:2px 5px;
                    font-size: 12px;
                }
            }
            .max-times{
                span{
                    margin-right: 8px;
                }
                margin-top: 16px;
            }
            .moods{
                span{
                    margin-right: 8px;
                }
                margin-top: 16px;
            }
            .interrupt{
                margin-top: 16px;
                span{
                    margin-right: 8px;
                }
                .ant-radio-button-wrapper{
                    color: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked:first-child{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                    box-shadow: none;
                }
            }
             .answer-type{
                margin-top: 16px;
                span{
                    margin-right: 8px;
                }
                label{
                    padding: 0 8px;
                }
                .ant-radio-button-wrapper{
                    color: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked:first-child{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                    box-shadow: none;
                }
            }
            .warning,.warning-danger{
                display: none;
                margin-top: 72px;
                li{
                    margin-top: 8px;
                    i.warn{
                        color:#FF9900;
                        font-size: 14px;
                    }
                    span.warn{
                        display: inline-block;
                        padding: 2px 8px 2px 0;
                        margin-left: 11px;
                        background: rgba(255, 195, 0, 0.45);
                        font-size: 12px;
                    }
                    i.danger{
                        color:#F5574E;
                        font-size: 14px;
                    }
                    span.danger{
                        display: inline-block;
                        padding: 2px 8px 2px 0;
                        margin-left: 11px;
                        background: rgba(255, 87, 51, 0.45);
                        font-size: 12px;
                    }
                }
            }
            .warning-danger{
                margin-top: 0px;
            }
        }
    }
</style>
